<div class="promo-card mat-elevation-z0 promo-marketplace rounded">
    <div class="bg-overlay">
        <img [ngSrc]="imgBg$()" alt="Promo Marketplace" fill>
        <div class="overlay" [ngClass]="bgIdx$()"></div>
    </div>
    <div class="promo-content">
        <div class="promo-header mb--24" *ngIf="title">
            <div class="promo-title">{{title}}</div>
        </div>
        <div class="mb--0" [innerHTML]="promoMarketplace$ | async"></div>
        <div class="promo-actions">
            <button mat-flat-button color="primary" (click)="GoToMarketplace()">{{ 'Go to Maretplace' | translate }}</button>
        </div>
    </div>
</div>